import React from 'react';
import NavBar from '../../components/Navbar/NavBar';
import FooterOne from '../../components/Footer/Footer';
import { Box, Grid, Typography, useTheme, useMediaQuery, } from '@mui/material';
import Accomplishments from '../../components/TembeaHighSchool/Accomplishments';
import SidebarSection from '../../components/TembeaHighSchool/SidebarSection';

const TembeaOverview = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            <NavBar />
            <Box sx={{
                mt: 6,
                backgroundImage: 'url("/assets/img/tembea/cover.jpg")',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <Typography variant={isMobile ? 'h3' : 'h2'} sx={{
                    color: '#fff',
                    textShadow: '2px 2px 8px #000',
                    fontWeight: 'bold',
                    fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
                    textAlign: 'center'
                }}>
                    TEMBEA HIGH SCHOOL
                </Typography>
            </Box>

            <Box sx={{ my: 5, textAlign: 'center' }}>
                <Typography variant="h4" gutterBottom textAlign='center' fontWeight='bold'>
                    OVERVIEW
                </Typography>
                <Typography variant='body1' sx={{ mx: 5, textAlign: 'center' }}>
                    At Tembea Beads High School, our students not only learn the required Kenyan curriculum but also develop the skills to prepare them to succeed for the rest of their lives, whether they continue on to college, enter the work force, or chose to marry and start their families.  Our goal is build a strong academic program based upon critical thinking, practical experience, reading and writing programs, environmental stewardship, community service, and also cultural understanding.
                </Typography>
            </Box>

            <Grid container spacing={3} sx={{ p: 2 }}>
                <Accomplishments />
                <SidebarSection />
            </Grid>

            <FooterOne />
        </Box>
    );
};

export default TembeaOverview;
